import type { Category } from "@/types/video";

export const categories: Category[] = [
  {
    slug: "film-news",
    name: "影视资讯",
    short: "资讯",
    description:
      "聚焦最新影视行业动态，涵盖新片预告、定档消息、电影节资讯与幕后花絮，第一时间掌握风向。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20premiere%20press%20event%20with%20microphones%20and%20warm%20spotlights%2C%20news%20and%20media%20atmosphere%2C%20high%20contrast%20orange%20tones%2C%20professional%20editorial%20photography%2C%20detailed%20composition&width=800&height=600&seq=rpvideo-cat-1&orientation=landscape",
    icon: "ri-newspaper-line",
  },
  {
    slug: "short-video",
    name: "短视频",
    short: "短片",
    description:
      "精选短内容与趣味片段，用几分钟读懂一个设定、看遍一处名场面，轻松又有料。",
    cover:
      "https://readdy.ai/api/search-image?query=bright%20playful%20short%20video%20montage%20concept%20with%20warm%20colorful%20light%20streaks%20and%20floating%20frames%2C%20energetic%20modern%20atmosphere%2C%20high%20contrast%20orange%20tones%2C%20editorial%20graphic%20still&width=800&height=600&seq=rpvideo-cat-2&orientation=landscape",
    icon: "ri-play-circle-line",
  },
  {
    slug: "hot-video",
    name: "热门视频",
    short: "热门",
    description:
      "高热度影视剪辑与名场面合集，紧跟全网讨论，看大家都在追什么。",
    cover:
      "https://readdy.ai/api/search-image?query=dramatic%20hot%20trending%20video%20scene%20with%20glowing%20embers%20and%20silhouetted%20figure%20in%20motion%2C%20intense%20fiery%20warm%20lighting%2C%20cinematic%20high%20contrast%2C%20epic%20composition%2C%20detailed%20film%20still&width=800&height=600&seq=rpvideo-cat-3&orientation=landscape",
    icon: "ri-fire-line",
  },
];